import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export const calculateDuration = (start: Date, end: Date) => {
  const startDate = dayjs(start)
  const endDate = dayjs(end)
  const diff = dayjs.duration(endDate.diff(startDate))
  const hours = diff.hours()
  const minutes = diff.minutes()
  let durationText = ''

  if (hours > 0) {
    durationText = minutes > 0 ? `${hours}h ${minutes}min` : `${hours}h`
  } else {
    durationText = `${minutes}min`
  }

  const durationInMinutes = diff.asMinutes()
  return { durationText, durationInMinutes }
}
